import {
  Editor,
  Transforms,
  Path
} from 'slate';

import elementTypes from '../../../elements/types';
import HelptapEditor from '../../';
import * as baseNodeUtilities from '../base-node';

import sourceCodeFileTypes from 'constants/source-code-file-types';

export function getDefaultOptions() {

  const options = baseNodeUtilities.getDefaultOptions();

  return options;

}

export function buildNode(options = {}, name = 'index.html', content = '<h1>Hello you!</h1>') {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.SOURCE_CODE_REGION,
    properties: {
      files: [{
        type: sourceCodeFileTypes.HTML,
        name,
        content
      }]
    }
  };

  return node;

}

function select(editor, path) {

  Transforms.select(editor, path);

}

function doInsert(editor, path) {

  const nodeOptions = buildNode();
  Transforms.insertNodes(editor, nodeOptions, { at: path });
  select(editor, path);

}

export function insert(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {
    doInsert(editor, nextNodePath);
  });

}

export function insertHTMLFile(editor, file) {

  const reader = new FileReader();

  reader.onload = function onLoad(event) {
    const content = event.target.result;
    const nodeOptions = buildNode({}, file.name, content);
    HelptapEditor.setNodeOptions(editor, nodeOptions);
  };

  reader.readAsText(file);

}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  Editor.withoutNormalizing(editor, () => {
    doInsert(editor, targetNodePath);
    Transforms.delete(editor, { at: Path.next(targetNodePath) });
  });

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}